"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _userflow = require("../../utils/userflow");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ToggleSwitchLabel = function ToggleSwitchLabel(_ref) {
  var isActive = _ref.isActive,
      children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement(StyledLabel, {
    onClick: isActive ? _userflow.preventEvent : undefined,
    className: className,
    isActive: isActive
  }, children);
};

ToggleSwitchLabel.defaultProps = {
  className: '',
  isActive: false
};
ToggleSwitchLabel.propTypes = {
  className: _propTypes["default"].string,
  isActive: _propTypes["default"].bool,
  children: _propTypes["default"].string.isRequired
};

var StyledLabel = _styledComponents["default"].div.withConfig({
  displayName: "ToggleSwitchLabel__StyledLabel",
  componentId: "sc-5ilvm7-0"
})(["cursor:pointer;color:", ";font-size:14px;", ""], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.blackLight;
}, function (_ref3) {
  var isActive = _ref3.isActive,
      theme = _ref3.theme;
  return isActive && (0, _styledComponents.css)(["color:", ";cursor:default;"], theme.colors.black);
});

var _default = ToggleSwitchLabel;
exports["default"] = _default;